import { AdminSession, SessionStatus } from '@airreading/common/data';
import { ReactNode } from 'react';
import { SessionStatusChangeModal } from './session-status-change-modal';

interface RestoreSessionsProps {
  sessions: AdminSession[];
  trigger: ReactNode;
  onSuccess?: () => void;
}

export const RestoreSessions = ({ sessions, trigger, onSuccess }: RestoreSessionsProps) => {
  const restorableSessions = sessions.filter((session) => session.status === SessionStatus.cancelled);

  return (
    <SessionStatusChangeModal
      sessions={restorableSessions}
      trigger={trigger}
      targetStatus={SessionStatus.scheduled}
      modalTitle="Are you sure you want to restore the following sessions?"
      confirmBtnLabel="Restore sessions"
      description="Sessions will be restored to scheduled status and students will be able to attend again."
      noValidSessionsMessage="None of the selected sessions can be restored. Only cancelled sessions can be restored to scheduled."
      invalidSessionsMessage="There are {count} sessions that cannot be restored. Only cancelled sessions can be restored to scheduled."
      buttonVariant="default"
      onSuccess={onSuccess}
    />
  );
};
